import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomModelBlogUrl,
  BackendQueryPerformanceCenterGetCustomModelBlogUrlArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOM_MODEL_BLOG_URL } from '../customModel/schema';

const QUERY = gql`
  query performanceCenterGetCustomModelBlogUrl($id: ID!) {
    performanceCenterGetCustomModelBlogUrl(id: $id) {
      ...CustomModelBlogUrl
    }
  }
  ${FRAGMENT_CUSTOM_MODEL_BLOG_URL}
`;

type Variables = BackendQueryPerformanceCenterGetCustomModelBlogUrlArgs;
type Result = BackendCustomModelBlogUrl;

export const performanceCenterGetCustomModelBlogUrl = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
